// extracted by mini-css-extract-plugin
export default {"returning":"kx-z","image":"lx-z","boxNum":"mx-z","boxedItems":"nx-z","buttons":"ox-z","disabled":"px-z"};